(function ($, document, window) {
	'use strict';

	function checkIfFeaturedCarouselNavNeed(sliderWrapper, sliderElement, nav, mqMatches) {
		const numSlides = sliderWrapper.querySelectorAll('.js-carousel-slide').length;
		const slidesWidth = sliderWrapper.scrollWidth;
		const sliderWidth = sliderElement.offsetWidth;

		if ((mqMatches && numSlides < 5) || (!mqMatches && slidesWidth <= sliderWidth)) {
			nav.addClass('featured-posts__nav--hidden');
		} else {
			nav.removeClass('featured-posts__nav--hidden');
		}
	}

	$(function () {
		$('.js-featured-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const sliderWrapper = $('.js-featured-carousel-wrapper', sliderContainer)[0];
			const navsContainer = $('.js-featured-carousel-navs', sliderContainer);
			const paginationEl = $(`.js-featured-carousel-pagination`, sliderContainer)[0];

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 'auto',
				loop: false,
				pagination: {
					el: paginationEl,
					type: 'bullets',
					clickable: true,
					bulletClass: 'featured-posts__pagination-bullet',
					bulletActiveClass: 'featured-posts__pagination-bullet--active'
				},

				breakpoints: {
					744: {
						slidesPerView: 'auto',
						spaceBetween: 28,
					},

					1280: {
						slidesPerView: 4,
						spaceBetween: 40,
					},
				},

				on: {
					resize: function () {
						const mq = window.matchMedia('(min-width: 1280px)').matches;
						checkIfFeaturedCarouselNavNeed(sliderWrapper, sliderEl, navsContainer, mq);
					},
					init: function () {
						const mq = window.matchMedia('(min-width: 1280px)').matches;
						checkIfFeaturedCarouselNavNeed(sliderWrapper, sliderEl, navsContainer, mq);
					},
					slideChange: function () {
						if (this.isBeginning) {
							$('.js-carousel-nav-prev', sliderContainer).addClass('is-disabled');
							$('.js-carousel-nav-prev', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-prev', sliderContainer).removeClass('is-disabled');
							$('.js-carousel-nav-prev', sliderContainer).removeAttr('disabled');
						}

						if (this.isEnd) {
							$('.js-carousel-nav-next', sliderContainer).addClass('is-disabled');
							$('.js-carousel-nav-next', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-next', sliderContainer).removeClass('is-disabled');
							$('.js-carousel-nav-next', sliderContainer).removeAttr('disabled');
						}
					},
				},
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
